import { z } from 'zod'
import { translate } from '@/i18n'

z.config({
  customError(issue) {
    switch (issue.code) {
      case 'invalid_type':
        return translate('Este campo é obrigatório')

      case 'too_small': {
        if (issue.minimum === 1) return translate('Este campo é obrigatório')
        const unit = issue.origin === 'string' ? translate('caracteres') : ''
        return translate('Mínimo de {{minimum}} {{unit}}', { minimum: issue.minimum, unit }).trim()
      }

      case 'too_big': {
        const unit = issue.origin === 'string' ? translate('caracteres') : ''
        return translate('Máximo de {{maximum}} {{unit}}', { maximum: issue.maximum, unit }).trim()
      }

      case 'invalid_format':
        if (issue.format === 'email') return translate('E-mail inválido')
        if (issue.format === 'url') return translate('URL inválida')
        if (issue.format === 'uuid') return translate('Identificador inválido')
        return translate('Formato inválido')

      case 'invalid_value':
        return translate('Opção inválida')

      default:
        return undefined
    }
  },
})
